module.exports = __webpack_public_path__ + "static/media/cyclone.922c98bd.png";